export default __webpack_public_path__ + "static/media/Payment.2a418f75.svg";